var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCanceled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0751 1H10.9249C10.7498 1 10.5764 1.03449 10.4146 1.10149C10.2529 1.1685 10.1059 1.26671 9.98206 1.39053L1.39053 9.98206C1.26671 10.1059 1.1685 10.2529 1.10149 10.4146C1.03449 10.5764 1 10.7498 1 10.9249V23.0751C1 23.2502 1.03449 23.4236 1.10149 23.5854C1.1685 23.7471 1.26671 23.8941 1.39053 24.0179L9.98206 32.6095C10.1059 32.7333 10.2529 32.8315 10.4146 32.8985C10.5764 32.9655 10.7498 33 10.9249 33H23.0751C23.2502 33 23.4236 32.9655 23.5854 32.8985C23.7471 32.8315 23.8941 32.7333 24.0179 32.6095L32.6095 24.0179C32.7333 23.8941 32.8315 23.7471 32.8985 23.5854C32.9655 23.4236 33 23.2502 33 23.0751V10.9249C33 10.7498 32.9655 10.5764 32.8985 10.4146C32.8315 10.2529 32.7333 10.1059 32.6095 9.98206L24.0179 1.39053C23.8941 1.26671 23.7471 1.1685 23.5854 1.10149C23.4236 1.03449 23.2502 1 23.0751 1Z",
    stroke: "#AFAFAF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L24 24",
    stroke: "#AFAFAF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceled);
export default __webpack_public_path__ + "static/media/canceled.393cd0fc89f93bdb820d08b585e6543c.svg";
export { ForwardRef as ReactComponent };